import React, { useEffect, useRef, useState } from 'react';

function BarcodeScanner({ onDetected, onClose }) {
  const videoRef = useRef(null);
  const readerRef = useRef(null);
  const detectedRef = useRef(false);
  const [status, setStatus] = useState('Запуск камеры…');
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const start = async () => {
      try {
        const { BrowserMultiFormatReader } = await import('@zxing/library');
        if (cancelled) return;
        const reader = new BrowserMultiFormatReader();
        readerRef.current = reader;
        setStatus('Наведите камеру на штрих-код или QR');
        await reader.decodeFromVideoDevice(null, videoRef.current, (result, err) => {
          if (cancelled || detectedRef.current) return;
          if (result) {
            detectedRef.current = true;
            const fmt = result.getBarcodeFormat();
            // Линейные штрихкоды: 1-4 (CODE_*), 6-8 (EAN/ITF), 12-16 (RSS/UPC)
            // 2D коды: 0 (AZTEC), 5 (DATA_MATRIX), 9 (MAXICODE), 10 (PDF_417), 11 (QR_CODE)
            const isLinear = (fmt >= 1 && fmt <= 4) || (fmt >= 6 && fmt <= 8) || (fmt >= 12 && fmt <= 16);
            const isQR = !isLinear;
            setStatus('Найдено! формат=' + fmt + (isQR ? ' (2D→ЧЗ)' : ' (штрихкод)'));
            console.log('[BarcodeScanner] format:', fmt, 'isQR:', isQR, 'code:', result.getText().substring(0, 60));
            setTimeout(() => {
              reader.reset();
              onDetected({ code: result.getText(), isQR });
            }, 600);
          }
        });
      } catch (e) {
        if (!cancelled) {
          console.error('[BarcodeScanner]', e);
          setError('Не удалось запустить камеру. Проверьте разрешение.');
        }
      }
    };

    start();
    return () => {
      cancelled = true;
      if (readerRef.current) {
        try { readerRef.current.reset(); } catch (_) {}
      }
      // Явно останавливаем треки, чтобы камера освободилась до открытия CameraModal
      if (videoRef.current && videoRef.current.srcObject) {
        try {
          videoRef.current.srcObject.getTracks().forEach(t => t.stop());
          videoRef.current.srcObject = null;
        } catch (_) {}
      }
    };
  }, [onDetected]);

  return (
    <div className="bs-wrap">
      <div className="bs-video-box">
        <video ref={videoRef} className="bs-video" autoPlay muted playsInline />
        <div className="bs-overlay">
          <div className="bs-frame">
            <div className="bs-line" />
          </div>
        </div>
      </div>
      <div className="bs-status">{error || status}</div>
      {error && (
        <button className="sm-btn sm-btn-search" onClick={onClose} style={{ marginTop: 4 }}>
          Закрыть
        </button>
      )}
    </div>
  );
}

export default BarcodeScanner;
